import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { BrowserModule } from "@angular/platform-browser";
import * as igx from "@infragistics/igniteui-angular";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { ChartJsContainerComponent } from "@tylertech/chart-js";
import { CommandsModule } from "@tylertech/commands-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CommonDialogsModule } from "@tylertech/common-dialogs-module";
import { CoreModule, NotificationActionInjector } from "@tylertech/core-module";
import { CustomViewModule } from "@tylertech/custom-view";
import { ForgeModule } from "@tylertech/forge-angular";
import { OdataModule } from "@tylertech/odata-module";
import { ImageCropperComponent } from "ngx-image-cropper";
import { QuillModule } from "ngx-quill";
import { MetadataActionDialogComponent } from "./components/metadataActionDialog/metadataActionDialog";
import { MetadataCalendarComponent } from "./components/metadataCalendar/metadataCalendar.component";
import { MetadataCalendarDayComponent } from "./components/metadataCalendar/metadataCalendarDay.component";
import { MetadataCalendarMonthComponent } from "./components/metadataCalendar/metadataCalendarMonth.component";
import { CardMetadataComponent } from "./components/metadataCard/card.metadata.component";
import { CardListComponent } from "./components/metadataCard/cardList/cardList.component";
import { CardListGroupComponent } from "./components/metadataCard/cardList/cardListGroup.component";
import { CardListItemBodyComponent } from "./components/metadataCard/cardList/cardListItemBody.component";
import { CardListItemHeaderComponent } from "./components/metadataCard/cardList/cardListItemHeader.component";
import { MetadataCardEditComponent } from "./components/metadataCard/metadataCard.edit.component";
import { MetadataCardViewComponent } from "./components/metadataCard/metadataCard.view.component";
import { MetadataChartComponent } from "./components/metadataChart/metadataChart.component";
import { MetadataCreateEntityDialogComponent } from "./components/metadataCreateEntityDialog/metadataCreateEntity.dialog";
import { MetadataDialogComponent } from "./components/metadataDialog/metadata.dialog";
import { MetadataAttachmentsComponent } from "./components/metadataForm/metadata.attachments.component";
import { MetadataFormComponent } from "./components/metadataForm/metadata.form.component";
import { MetadataViewComponent } from "./components/metadataForm/metadata.view.component";
import { MetadataActionComponent } from "./components/metadataForm/metadataAction.component";
import { MetadataActionMenuComponent } from "./components/metadataForm/metadataActionMenu.component";
import { MetadataNavigationLeafComponent } from "./components/metadataForm/navigation/metadataNavigationLeaf.component";
import { MetadataNavigationTreeComponent } from "./components/metadataForm/navigation/metadataNavigationTree.component";
import { MetadataViewNavigationListComponent } from "./components/metadataForm/navigation/metadataViewNavigationList.component";
import { MetadataGenericButtonComponent } from "./components/metadataInput/controls/actionable/metadata-generic-button.component";
import { MetadataIconButtonComponent } from "./components/metadataInput/controls/actionable/metadata-icon-button.component";
import { MetadataLinkComponent } from "./components/metadataInput/controls/actionable/metadata-link.component";
import { MetadataTextButtonComponent } from "./components/metadataInput/controls/actionable/metadata-text-button.component";
import { MetadataBadgeComponent } from "./components/metadataInput/controls/badge/metadata-badge.component";
import { MetadataInputCheckboxComponent } from "./components/metadataInput/controls/checkbox/metadata-input-checkbox.component";
import { MetadataInputColorComponent } from "./components/metadataInput/controls/color/metadata-input-color.component";
import { MetadataInputDateComponent } from "./components/metadataInput/controls/date/metadata-input-date.component";
import { MetadataInputDateTimeComponent } from "./components/metadataInput/controls/datetime/metadata-input-date-time.component";
import { MetadataInputFileComponent } from "./components/metadataInput/controls/file/metadata-input-file.component";
import { MetadataHtmlComponent } from "./components/metadataInput/controls/html/metadataHtml.component";
import { MetadataInputInlineMessageComponent } from "./components/metadataInput/controls/inlineMessage/metadata-inline-message.component";
import { MetadataHeaderComponent } from "./components/metadataInput/controls/label/metadata-header.component";
import { MetadataLabelComponent } from "./components/metadataInput/controls/label/metadata-label.component";
import { MetadataInputLabelValueComponent } from "./components/metadataInput/controls/labelValue/metadata-label-value.component";
import { MetadataInputNumberComponent } from "./components/metadataInput/controls/number/metadata-input-number.component";
import { MetadataInputPhoneNumberComponent } from "./components/metadataInput/controls/phoneNumber/metadata-input-phone-number.component";
import { MetadataRichTextComponent } from "./components/metadataInput/controls/richText/metadata-rich-text.component";
import { MetadataScriptComponent } from "./components/metadataInput/controls/script/metadataScript.component";
import { MetadataInputDualListComponent } from "./components/metadataInput/controls/select/metadata-input-dual-list.component";
import { MetadataInputMultiSelectComponent } from "./components/metadataInput/controls/select/metadata-input-multi-select.component";
import { MetadataInputSelectComponent } from "./components/metadataInput/controls/select/metadata-input-select.component";
import { MetadataInputTextComponent } from "./components/metadataInput/controls/text/metadata-input-text.component";
import { MetadataInputTextAreaComponent } from "./components/metadataInput/controls/text/metadata-input-textarea.component";
import { MetadataInputTimeComponent } from "./components/metadataInput/controls/time/metadata-input-time.component";
import { MetadataInputTypeaheadComponent } from "./components/metadataInput/controls/typeahead/metadata-input-typeahead.component";
import { MetadataInputComponent } from "./components/metadataInput/metadataInput.component";
import { EditOnlyMetadataCardComponent, MetadataCardComponent } from "./components/metadataPanel/metadataCard.component";
import { MetadataPanelComponent, MetadataSummaryPanelComponent } from "./components/metadataPanel/metadataPanel.component";
import { MetadataPanelGridComponent } from "./components/metadataPanelGrid/metadataPanelGrid.component";
import { MetadataPanelGridActionComponent } from "./components/metadataPanelGrid/metadataPanelGridActions.component";
import { MetadataPhotoComponent } from "./components/metadataPhoto/metadataPhoto.component";
import { MetadataPhotoCropDialogComponent } from "./components/metadataPhoto/metadataPhotoCropDialog.component";
import { MetadataSpatialMapComponent } from "./components/metadataSpatialMap/metadataSpatialMap.component";
import { CellEditOverlay } from "./components/metadataTable/infoGrid/cellEditOverlay.component";
import { ColumnMoveSelectorComponent } from "./components/metadataTable/infoGrid/columnMoveSelector.component";
import { GridContextComponent } from "./components/metadataTable/infoGrid/gridContext.component";
import { GridFilterComponent } from "./components/metadataTable/infoGrid/gridFilter.component";
import { GridSearchComponent } from "./components/metadataTable/infoGrid/gridSearch.component";
import { InfoGridComponent } from "./components/metadataTable/infoGrid/infoGrid.component";
import { RowActionsComponent } from "./components/metadataTable/infoGrid/rowActions.component";
import { MetadataTableComponent } from "./components/metadataTable/metadataTable/metadata.table.component";
import { MetadataTreeComponent } from "./components/metadataTree/metadataTree/metadata.tree.component";
import { TreeViewComponent } from "./components/metadataTree/treeView/treeView.component";
import { MetaFormBlankComponent } from "./components/metaform/metaform.blank.component";
import { MetaFormComponent } from "./components/metaform/metaform.component";
import { FocusOnLoadDirective } from "./directives/focusOnLoad.directive";
import { GridCurrencyPipe } from "./pipes/gridCurrency.pipe";
import { GridNumberPipe } from "./pipes/gridNumber.pipe";
import { OrderByPipe } from "./pipes/orderBy.pipe";
import { CachedCodeLookupService, CodeLookupService, GridLayoutService, MetadataActionService } from "./services";

const angularModules = [
    BrowserModule,
    CommonModule,
    FlexLayoutModule,
    FlexModule,
    FormsModule,
];

const angularMaterialModules = [
    MatDialogModule
];

const lgdModules = [
    ChartJsContainerComponent,
    CommandsModule,
    CommonComponentsModule,
    CommonDialogsModule,
    CoreModule,
    CustomViewModule,
    OdataModule,
];

const exportedComponents = [
    MetadataCardComponent,
    MetadataFormComponent,
    MetadataInputComponent,
    MetadataPanelComponent,
    MetadataPanelGridComponent,
    MetadataTableComponent,
    MetadataViewComponent,
    MetaFormBlankComponent,
    MetaFormComponent,
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules,
        ForgeModule,
        igx.IgxActionStripModule,
        igx.IgxCheckboxModule,
        igx.IgxForOfModule,
        igx.IgxDropDownModule,
        igx.IgxToggleModule,
        igx.IgxGridModule,
        igx.IgxInputGroupModule,
        igx.IgxTreeModule,
        QuillModule,
        ImageCropperComponent
    ],
    declarations: [
        ...exportedComponents,
        CardListComponent,
        CardListGroupComponent,
        CardListItemBodyComponent,
        CardListItemHeaderComponent,
        CardMetadataComponent,
        CellEditOverlay,
        ColumnMoveSelectorComponent,
        EditOnlyMetadataCardComponent,
        FocusOnLoadDirective,
        GridContextComponent,
        GridCurrencyPipe,
        GridFilterComponent,
        GridSearchComponent,
        GridNumberPipe,
        InfoGridComponent,
        MetadataActionComponent,
        MetadataActionDialogComponent,
        MetadataActionMenuComponent,
        MetadataAttachmentsComponent,
        MetadataBadgeComponent,
        MetadataCalendarComponent,
        MetadataCalendarDayComponent,
        MetadataCalendarMonthComponent,
        MetadataCardEditComponent,
        MetadataCardViewComponent,
        MetadataChartComponent,
        MetadataCreateEntityDialogComponent,
        MetadataDialogComponent,
        MetadataGenericButtonComponent,
        MetadataHeaderComponent,
        MetadataHtmlComponent,
        MetadataIconButtonComponent,
        MetadataInputCheckboxComponent,
        MetadataInputColorComponent,
        MetadataInputDateComponent,
        MetadataInputDateTimeComponent,
        MetadataInputDualListComponent,
        MetadataInputFileComponent,
        MetadataInputInlineMessageComponent,
        MetadataInputLabelValueComponent,
        MetadataInputMultiSelectComponent,
        MetadataInputNumberComponent,
        MetadataInputPhoneNumberComponent,
        MetadataInputSelectComponent,
        MetadataInputTextAreaComponent,
        MetadataInputTextComponent,
        MetadataInputTimeComponent,
        MetadataInputTypeaheadComponent,
        MetadataLabelComponent,
        MetadataLinkComponent,
        MetadataNavigationLeafComponent,
        MetadataNavigationTreeComponent,
        MetadataPanelGridActionComponent,
        MetadataPhotoComponent,
        MetadataPhotoCropDialogComponent,
        MetadataRichTextComponent,
        MetadataScriptComponent,
        MetadataSpatialMapComponent,
        MetadataSummaryPanelComponent,
        MetadataTextButtonComponent,
        MetadataTreeComponent,
        MetadataViewNavigationListComponent,
        OrderByPipe,
        RowActionsComponent,
        TreeViewComponent,
    ],
    exports: exportedComponents,
    providers: [
        CachedCodeLookupService,
        CodeLookupService,
        GridLayoutService,
        { provide: NotificationActionInjector, useClass: MetadataActionService }
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MetadataModule { }
